import { useEffect, useState } from "react";
import React from "react";
import CoinReward from "./CoinReward";
import Information from "./Information";
import Notification from "./Notification";
import Language from "./Language";
import EnglandFlag from "../../../../../src/assets/images/all/Eng_flag.png";
import IndonesiaFlag from "../../../../../src/assets/images/all/Ind_flag.png";
import coin from "../../../../assets/images/topbar/reward.svg";
import information from "../../../../assets/images/topbar/information.svg";
import jackpot from "../../../../assets/images/topbar/jackpot.svg";
import tutorial from "../../../../assets/images/topbar/tutorial.svg";
import notification from "../../../../assets/images/all/notification_1.svg";
import logout from "../../../../assets/images/topbar/logout.svg";
import eng from "../../../../assets/images/topbar/ENG.svg";
import pro from "../../../../assets/images/mo_icon/PROFILE.svg";
import reward from "../../../../assets/images/mo_icon/COIN REWARD.svg";
// import trophy from '../../../../assets/images/mo_icon/TROPHY.svg'
import infor from "../../../../assets/images/mo_icon/INFOR.svg";
import noti from "../../../../assets/images/mo_icon/NOTIFICATION BELL.svg";
import exit from "../../../../assets/images/mo_icon/EXIT.svg";
import tutorialmo from "../../../../assets/images/mo_icon/tutorialmo.svg";

import arrow from "../../../../assets/images/mo_icon/mo_arrow_left.svg";
import { IconButton } from "@mui/material";
import { TOKEN_KEY } from "../../../../helpers/url_helper";
import { formatPrice } from "../../../NumberFormat";
import { FaSync } from "react-icons/fa";
import Snowman from "../../../../assets/images/FestiveTheme/snow-man.svg";
import promotion_img from "../../../../assets/images/topbar/Promotion_DingDong.svg";
import cardgameTop from "../../../../assets/images/topbar/cardgameTop.svg";
import togelTop from "../../../../assets/images/topbar/togelTop.svg";
import ArcadeTop from "../../../../assets/images/topbar/arcadeTop.svg";
// import { SiApplearcade } from "react-icons/si";

import PromoIcon from "../../../../assets/images/sidebar/promo.svg";
import NewIcon from "../../../../assets/images/sidebar/new.svg";
import HotTagIcon from "../../../../assets/images/sidebar/hot.svg";

import {
  makeAjax,
  respStatus,
  showMessage,
  socket,
  url,
} from "../../../../helpers/global_helper";
import { Link, redirect, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import InnerPopup from "../../../Modal/InnerPopup";
import CoachMarkPopup from "../../../Modal/CoachMarkPopup";
import { setCurrentStep } from "../../../../redux/actions";
import Promotion from "../../../Promotion/Promotion";
import Jackpot from "./Jackpot";

const HeaderRightMenu = (props) => {
  const user_profile = useSelector(state => state.UserProfile);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const [isOpen, setIsOpen] = useState(false);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [isRefreshing, setISRefreshing] = useState(false);
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  const depositUrl = sessionStorage.getItem("depositUrl");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [popup, setPopup] = useState(null);
  const [activeIcon, setActiveIcon] = useState(null);
  let lang = localStorage.getItem("I18N_LANGUAGE")
    ? localStorage.getItem("I18N_LANGUAGE")
    : "id";
  const [iconList, setIconList] = useState([]);
  const handleClose = () => {
    setPopup(null);
    setActiveIcon(null);
  };
  const closeUploadimgpoppup = () => {
    setPopup(false)
  }
  const handleLogout = () => {
    setPopup(
      <div className="logout_modal">
        <InnerPopup onCloseModal={closeUploadimgpoppup} modalHeader={true} modalTitle="Message">
          <div className="nick_success_message">
            <p> {props.t("you_ve_been_logged_out_successfully")}</p>
          </div>
        </InnerPopup>
      </div>
    );
    makeAjax(url.PLAYER_API.logout, {}, url.PLAYER_MS_EXT).then((response) => {
      if (response.status === respStatus["SUCCESS"]) {
        showMessage(response)
        localStorage.removeItem(TOKEN_KEY);
      }
    });
  };

  useEffect(() => {
    socket.on("remove_user", (userId) => {
      const currentUserId = localStorage.getItem("user_id");

      if (String(userId) === String(currentUserId)) {
        handleLogout()
        socket.disconnect();
        window.location.href = "/sessionexpirelogout";
      }
    });
  }, [socket])

  const handleRefreshBalance = async () => {
    setISRefreshing(true);
    const currentTime = new Date().getTime();
    const newClickTime = (currentTime - lastClickTime) / 1000;
    if (newClickTime < 8) {
      const remainingTime = Math.ceil(8 - newClickTime);
      setISRefreshing(false);
      showMessage(
        `Please try again after  ${remainingTime}  second `,
        "error",
        "Message"
      );
    } else {

      setLastClickTime(currentTime);
    }
  };

  const onLanguageChange = (lang) => {
    setCurrentLang(lang);
    setPopup(null);
  };

  const [labelMap, setLabelMap] = useState([]);
  useEffect(() => {
    console.log("user_profile.button_label_lobby", user_profile.button_label_lobby);
    if (user_profile.button_label_lobby) {
      const labelMap = Object.fromEntries(
        user_profile.button_label_lobby.split(";").map(pair => {
          const [key, values] = pair.split(":");
          return [key, values ? values.split(",") : []];
        })
      );
      setLabelMap(labelMap);
      console.log(labelMap);
    }
  }, [user_profile]);


  const icons = [

    {
      src: lang == "en" ? EnglandFlag : IndonesiaFlag,
      alt: (props.t("language")),
      popup: (
        <Language onClose={handleClose} onLanguageChange={onLanguageChange} />
      ),
      id: "language",
    },
    {
      src: jackpot,
      alt: (props.t("jackpot")),
      popup: <Jackpot onClose={handleClose} />,
      id: "jackpot",
    },
    { src: coin, alt: (props.t("coin_reward", { defaultValue: "Coin Reward" })), popup: <CoinReward onClose={handleClose} />, id: 'CoinReward' },
    { src: promotion_img, alt: (props.t("Promotion")), popup: <Promotion onClose={handleClose} />, id: "promotion" },
    {
      src: tutorial,
      alt: (props.t("tutorial")),
      id: "tutorial",
    },
    {
      src: information,
      alt: (props.t("information")),
      popup: <Information onClose={handleClose} />,
      id: "information",
    },

    {
      src: notification,
      alt: (props.t("notification")),
      popup: <Notification onClose={handleClose} />,
      id: "notification",
    },
    ...(Number(user_profile.TGGameCount) > 0
      ? [
        {
          src: togelTop,
          alt: props.t("Togel"),
          id: "togelIcon",
          blink: labelMap.togel ? labelMap.togel : "",
          onClick: () => redirectLobby("togel"),
        },
      ]
      : []),

    ...(Number(user_profile.CGGameCount) > 0
      ? [
        {
          src: cardgameTop,
          alt: props.t("Card Games"),
          id: "cardGameIcon",
          onClick: () => redirectLobby("cardgame"),
          blink: labelMap.cardgames ? labelMap.cardgames : ""
        },
      ]
      : []),
    ...(Number(user_profile.ARGameCount) > 0
      ? [
        {
          src: ArcadeTop,
          alt: props.t("Arcade"),
          id: "cardGameIcon",
          onClick: () => redirectLobby("arcade"),
          blink: labelMap.arcade ? labelMap.arcade : ""
        },
      ]
      : []),
    { src: logout, alt: (props.t("logout")), onClick: handleLogout, id: "logout" },


  ];
  const [current_lang, setCurrentLang] = useState(lang);



  const handleIconClick = (icon, id) => {
    setPopup(null);
    setPopup(icon.popup);
    setActiveIcon(id);
    if (id === "tutorial") {
      dispatch(setCurrentStep(0));
    }
  };

  const handleShowCoachMark = (() => {
    dispatch(setCurrentStep(0));
  })

  const handleIconButtonClick = (icon, id) => {
    if (icon.onClick) {
      icon.onClick();
    } else {
      handleIconClick(icon, id);
    }
  };

  useEffect(() => {
    if (current_lang) {
      let tempIconList = icons;
      tempIconList[0].src = current_lang == "en" ? EnglandFlag : IndonesiaFlag;
      setIconList(tempIconList);
    }
    setActiveIcon(null)
  }, [current_lang, props.t, user_profile.CGGameCount, labelMap]);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeMenu = () => {
    setIsOpen(false);
    const menu = document.getElementById('menu');
    if (menu) {
      menu.scrollTop = 0;
    };
  };
  const handleMobileLogout = () => {
    closeMenu();
    handleLogout();
  }

  const handleLanguageClick = () => {
    const languageIcon = icons.find((icon) => icon.id === "language");
    setActiveIcon("language");
    handleIconButtonClick(languageIcon, "language");
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024); // Adjust breakpoint as needed
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isCoachMarkActive = currentStep === (isMobile ? 3 : 5);
  useEffect(() => {
    if (currentStep === 7 && isMobile) {
      setIsOpen(true);
    }

    if (currentStep === 9 && isMobile) {
      setIsOpen(false);
    }
    if ((currentStep === 2 || currentStep === 3) && isMobile) {
      setIsOpen(false);
    }
  }, [currentStep]);

  const handleCheckNewUser = () => {
    makeAjax(url.PLAYER_API.getCoachDetails, {}, url.PLAYER_MS_EXT)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        if (response.data.value === 0) {
          dispatch(setCurrentStep(0))
        }
        else {
          dispatch(setCurrentStep(-1))

        }
      }).catch((error) => {
        console.error("Error fetching CoachMark status:", error);
      });
  }

  useEffect(() => {
    handleCheckNewUser()
  }, []);

  const redirectLobby = (lobbyValue) => {
    let gameType = '';
    if (lobbyValue == 'togel') {
      gameType = 5;
    } else if (lobbyValue == 'cardgame') {
      gameType = 3;
    } else if (lobbyValue == 'arcade') {
      gameType = 7;
    }
    makeAjax(url.PLAYER_API.redirectLobby, { "gameType": gameType, "depositUrl": depositUrl }, url.PLAYER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      handleLogout();
      localStorage.clear();
      window.location.replace(response.data.link);
    })
  }

  return (
    <div className={`main_navigation`} style={{
      zIndex: isCoachMarkActive ? -10 : "auto",
    }}>
      <div className="festiveTheme-img2-placeholder">
        <img src={Snowman} alt="" />
      </div>
      <div className='hamburger'>
        <nav role='navigation'>
          <div className={`mo_nav custom-tooltip-wrapper ${isMobile && currentStep === 5 ? "highlighted" : ""}`} style={{
            zIndex: currentStep === 4 && isMobile ? -10 : "revert-layer",
          }}>
            <img className='mo_lang' src={lang == 'en' ? EnglandFlag : IndonesiaFlag} onClick={handleLanguageClick}></img>
            <p>{(props.t("language"))}</p>
            {isMobile && currentStep === 5 && <CoachMarkPopup />}

          </div>
          {isMobile && currentStep === 5 && <div className="custom-overlay"></div>}

          <div id="menuToggle" className={`menu-toggle custom-tooltip-wrapper ${isMobile && currentStep === 6 ? "highlighted" : ""}`} style={{
            zIndex:
              currentStep === 4 && isMobile
                ? -10
                : isMobile && currentStep === 6
                  ? 9
                  : "auto",
          }}>
            <div className="hamburg-child"><input type="checkbox" checked={isOpen} onChange={toggleMenu} />
              <span className="top-menu"></span>
              <span className="top-menu"></span>
              <span className="top-menu"></span>
              <div className="hambergerOverlay" onClick={closeMenu}></div>
              <ul id="menu" style={{ opacity: currentStep === 0 || currentStep === 1 ? 0 : 1, overflow: currentStep === 7 || currentStep === 8 ? 'visible' : 'auto' }}>
                <li>
                  {/* <img
                    src={user_profile.myAvatarLink}
                    alt=""
                  /> */}
                  {" "}
                  <div>
                    {user_profile.nickname} <span> {user_profile.curr} {formatPrice(user_balance.coin)}
                      <div className=" refrash_icon_hamburg" onClick={handleRefreshBalance}>
                        <FaSync className={isRefreshing ? "refreshing" : ""} />

                      </div>
                    </span>
                  </div>

                </li>
                {/* <li>
                  <Link to={"/profile"} onClick={closeMenu}>
                    <img src={pro} alt="" /> {props.t("profile")}{" "}
                    <span>
                      <img src={arrow}></img>
                    </span>
                  </Link>
                </li> */}

                <li className={`conin-reward custom-tooltip-wrapper ${currentStep === 7 ? "highlighted " : ""}`}>
                  <Link to={"/coinReward"} onClick={closeMenu}>
                    <img src={reward} alt="" /> {props.t("coin_reward")}{" "}
                    <span>
                      <img src={arrow}></img>
                    </span>
                  </Link>
                  {currentStep == 7 && <CoachMarkPopup />}

                </li>
                {currentStep === 7 && <div className="custom-overlay"></div>}
                <li className={`log-out  `}>
                  <Link onClick={handleShowCoachMark}>
                    <img src={tutorialmo} alt="" /> Tutorial
                    <span>
                      <img src={arrow}></img>
                    </span>
                  </Link>

                </li>
                <li>
                  <Link to={"/promotion"} onClick={closeMenu}>
                    <img src={promotion_img} alt="" /> {props.t("promotion")}
                    <span>
                      <img src={arrow}></img>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to={"/information"} onClick={closeMenu}>
                    <img src={infor} alt="" /> {props.t("information")}{" "}
                    <span>
                      <img src={arrow}></img>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to={"/notification"} onClick={closeMenu}>
                    <img src={noti} alt="" />
                    {props.t("notification")}
                    <span>
                      {/* <img src={arrow}></img> */}
                    </span>
                  </Link>
                </li>

                {(user_profile.TGGameCount > 0 ?
                  <li>
                    <Link onClick={() => redirectLobby('togel')}>
                      <img src={togelTop} alt="" />
                      {props.t("Togel")}
                      {(labelMap.togel && ((labelMap.togel.includes("blink") && labelMap.togel.includes("promo")) || labelMap.togel.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
                      {(labelMap.togel && ((labelMap.togel.includes("blink") && labelMap.togel.includes("new")) || labelMap.togel.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
                      {(labelMap.togel && ((labelMap.togel.includes("blink") && labelMap.togel.includes("hot")) || labelMap.togel.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}
                      <span>
                        <img src={arrow}></img>
                      </span>
                    </Link>
                  </li>
                  : '')}

                {(user_profile.CGGameCount > 0 ?
                  <li>
                    <Link onClick={() => redirectLobby('cardgame')}>
                      <img src={cardgameTop} alt="" />
                      {props.t("Card Games")}
                      {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("promo")) || labelMap.cardgames.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
                      {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("new")) || labelMap.cardgames.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
                      {(labelMap.cardgames && ((labelMap.cardgames.includes("blink") && labelMap.cardgames.includes("hot")) || labelMap.cardgames.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}

                      <span>
                        <img src={arrow}></img>
                      </span>
                    </Link>
                  </li>
                  : '')}

                {(user_profile.ARGameCount > 0 ?
                  <li>
                    <Link onClick={() => redirectLobby('arcade')}>
                      <img src={ArcadeTop} alt="" />
                      {props.t("Arcade")}
                      {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("promo")) || labelMap.arcade.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
                      {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("new")) || labelMap.arcade.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
                      {(labelMap.arcade && ((labelMap.arcade.includes("blink") && labelMap.arcade.includes("hot")) || labelMap.arcade.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}

                      <span>
                        <img src={arrow}></img>
                      </span>
                    </Link>
                  </li>
                  : '')}

                <li>
                  <Link to={"/jackpot"} onClick={closeMenu}>
                    <img src={jackpot} alt="" />
                    {props.t("jackpot")}
                    <span>
                      <img src={arrow}></img>
                    </span>
                  </Link>
                </li>
                <li className={`log-out custom-tooltip-wrapper ${currentStep === 8 ? "highlighted " : ""}`}>
                  <Link onClick={handleMobileLogout}>
                    <img src={exit} alt="" /> {props.t("logout")}
                    <span>
                      <img src={arrow}></img>
                    </span>
                  </Link>
                  {isMobile && currentStep == 8 && <CoachMarkPopup />}
                </li>
                {isMobile && currentStep === 8 && <div className="custom-overlay"></div>}

              </ul>
            </div>
            <p>{(props.t("Menu"))}</p>
            {isMobile && currentStep === 6 && <CoachMarkPopup />}

          </div>
          {isMobile && currentStep === 6 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}
        </nav>


      </div>

      <div className="d-menu">
        <ul >
          {iconList &&
            iconList.length &&
            iconList.map((icon, index) => (
              <React.Fragment key={index}>
                <li className={`right-icons custom-tooltip-wrapper ${icon.id === "language" ? "lang_icon" : ""} ${activeIcon === icon.id ? "" : ""} 
                ${currentStep === 6 && icon.title === props.t('Togel') ? "highlighted" : ""}
              ${currentStep === 7 && icon.title === props.t('Card Games') ? "highlighted" : ""}
                ${currentStep === 0 && icon.id === "language" ? "highlighted lang" : ""}
                 ${currentStep === 1 && icon.id === "CoinReward" ? "highlighted coin-reward" : ""}  
                ${currentStep === 2 && icon.id === "information" ? "highlighted info" : ""} 
                ${currentStep === 3 && icon.id === "notification" ? "highlighted notifi" : ""} 
                ${currentStep === 4 && icon.id === "logout" ? "highlighted logout" : ""}`}
                  style={currentStep === 5 ? { zIndex: -10 } : {}}>
                  <IconButton
                    onClick={() => handleIconButtonClick(icon, icon.id)}

                  >
                    <img src={icon.src} alt="" />
                  </IconButton>

                  {(icon.blink && ((icon.blink.includes("blink") && icon.blink.includes("promo")) || icon.blink.includes("promo"))) ? <div className="sidebar_tag"><img className="blink_img" src={PromoIcon} alt="" /></div> : ""}
                  {(icon.blink && ((icon.blink.includes("blink") && icon.blink.includes("new")) || icon.blink.includes("new"))) ? <div className="sidebar_tag"><img className="blink_img" src={NewIcon} alt="" /></div> : ""}
                  {(icon.blink && ((icon.blink.includes("blink") && icon.blink.includes("hot")) || icon.blink.includes("hot"))) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : ""}
                  {/* {(icon.blink && (icon.blink.includes("blink") && icon.blink.includes("off")) || icon.blink.includes("off")) ? <div className="sidebar_tag"><img className="blink_img" src={HotTagIcon} alt="" /></div> : "" } */}

                  <div className="icon-text">{icon.alt}</div>
                  {icon.src === notification ? (
                    <span className="notify_count">{user_balance.countNotif}</span>
                  ) : null}

                  {icon.src === jackpot ? (
                    <span className="notify_count">{user_balance.countNotifBigbang}</span>
                  ) : null}

                  {currentStep == 0 && index == 0 && <CoachMarkPopup />}
                  {currentStep == 1 && index == 1 && <CoachMarkPopup />}
                  {currentStep === 2 && icon.id === "information" && <CoachMarkPopup />}
                  {currentStep === 3 && icon.id === "notification" && <CoachMarkPopup />}
                  {currentStep === 4 && icon.id === "logout" && <CoachMarkPopup />}


                </li>
                {currentStep === 0 && <div className="custom-overlay"></div>}
                {currentStep === 1 && <div className="custom-overlay"></div>}
                {currentStep === 2 && <div className="custom-overlay"></div>}
                {currentStep === 3 && <div className="custom-overlay"></div>}
                {currentStep === 4 && <div className="custom-overlay"></div>}



              </React.Fragment>
            ))}
        </ul>
      </div>
      {popup}


    </div>
  );
};
export default withTranslation()(HeaderRightMenu);